/* eslint-disable max-len */
import React from 'react';
import DashboardWrap from '../../components/DashboardWrap';
import RewardsCards from './RewardCards';
import RewardChart from './RewardChart';
import RewardRecordSection from './RewardRecordSection';
import Styles from './Rewards.module.scss';

const Rewards = () => (
  <DashboardWrap>
    <div className={Styles.wrapper}>
      <RewardsCards />
      <RewardChart />
      <RewardRecordSection />

    </div>
  </DashboardWrap>
);

export default Rewards;
